// extracted by css-extract-rspack-plugin
export default {"result":"SUF5z4AfI08IYq_A"};